module.exports = __webpack_public_path__ + "static/media/inviteBg@2x.c88a2c2c.png";